import { addOriginalCase, formatPhone } from "../utility/api-utilities";
import { CelRequest, Facet, Result, PrekSchool, SCHOOL_TYPE } from "../interfaces"
// @TODO pull this into a better place
//const contentId = (window as any).bootstrap.contentId;
// @ts-ignore
const contentId = window.cpsContentId ? window.cpsContentId : '10375' // pull this out

//const BASE_URL = 'https://dev.secure.cps.edu/webapiinternet/api/'
//const BASE_URL = 'https://preintegration.cps.edu/api/'
//const BASE_URL = 'https://integration.cps.edu/api/'
//const BASE_URL = 'https://www.cps.edu/api/'
const EPI_URL = '/api/'

// @ts-ignore
const API_URL = window.schoolSearchApiUrl ? window.schoolSearchApiUrl : 'https://api.cps.edu/';

const EnrollmentYear = (window as any).bootstrap.enrollmentYear;

export function getSchoolProfile(id) {
    return Promise.all([
        fetch(`${EPI_URL}schoolprofile/singleschoolprofile?SchoolID=${id}`).then(res => res.json()),
        fetch(`${EPI_URL}schoolprofile/SchoolProgressReport?SchoolID=${id}`).then(res => res.json()),
        fetch(`${EPI_URL}schoolprofile/ECECPSSchoolData?EnrollmentYear=${EnrollmentYear}&schoolCode=${id}`).then(res => res.json())
    ]).then((values) => {
        let [profile, progress, prek] = values;
        profile._progressReport = progress[0];
        profile._prek = addOriginalCase(prek[0]);
        profile.fax = formatPhone(profile.fax)
        profile.phone = formatPhone(profile.phone)
        return profile;
    });
}

// not used
export function getAllCpsSchoolProfiles() {
    return fetch(`${API_URL}schoolprofile/CPS/AllSchoolProfiles`)
        .then((res) => res.json())
        .then(res => {
            return res;
        })
        .then(res => {
            return res.map(school => {
                school.type = SCHOOL_TYPE.CPS;
                return school;
            })
        })

}

export function formatedCPSSchools(schools: Result[]): PrekSchool[] {
    return schools.map((profile: Result): PrekSchool => {
        return {
            type: 'cps',
            _epi: {
                ...profile,
                facets: {
                    id: ['' + profile.id],
                    ...profile.facets
                }
            }
        }
    })
}

export function getAllCpsSchools(withProfiles = false) {
    // Can lazy load the profiles if laoding time is an issue, but that endpoint seems fast
    //return Promise.all([getAllCpsSchoolsExistingSearch(), getAllCpsSchoolProfiles()])

    return getAllCpsSchoolsExistingSearch()
        .then(res => {
            return res;
        })

}

export function getAllCpsSchoolsExistingSearch() {
    let params = {
        "searchTerm": "",
        "pageSize": 1000,
        "pageNumber": 1,
        "facets": [],
        "context": "Schools",
        "dateSortRelevanceFilter": 0,
        "contentID": contentId
    }
    return fetch(`${EPI_URL}v1/search/results`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(res => res.json())
        .then(res => {
            return res as CelRequest
        })
        ;
}

// called, not used
export function search(term, fats = []) {
    let facets = [];
    let params = {
        "searchTerm": term,
        "pageSize": 1000,
        "pageNumber": 1,
        "facets": facets,
        "context": "Schools",
        "dateSortRelevanceFilter": 0,
        "contentID": contentId
    };
    return fetch(`${EPI_URL}v1/search/results`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(res => res.json())
        .then(res => {
            return res.results
        })
        ;
}


let pageProperties = null;

export function getPageProperties(): Promise<any> {
    let contentId = (window as any).bootstrap.contentId;
    if (pageProperties) {
        return Promise.resolve(pageProperties);
    }
    return fetch(`${EPI_URL}v1/content/properties?contentId=${contentId}&includeGlobalSettingClientProperties=true`)
        .then(res => res.json())
        .then(json => {
            pageProperties = json;
            return json;
        })
}

let cpsCurrentYear = null;
export function getCPSCurrentYear(): Promise<any> {
    const url = "https://api.cps.edu/district/cps/CurrentYear";
    if (cpsCurrentYear) {
        return Promise.resolve(cpsCurrentYear);
    }
    return fetch(url)
        .then(res => res.json())
        .then(json => {
            cpsCurrentYear = json;
            return json;
        })
}

export function getSearchBarProperties() {
    return fetch(`${EPI_URL}v1/content/properties?contentId=${contentId}&includeGlobalSettingClientProperties=true`)
        .then(res => res.json())
}